document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-card').forEach(card => {
    const video = card.querySelector('.product-card__video');

    if (video) {
      let isPlaying = false;

      card.addEventListener('mouseenter', () => {
        if (!isPlaying) {
          video.play().then(() => {
            isPlaying = true;
          }).catch(err => {
            console.warn('Video play aborted:', err);
          });
        }
      });

      card.addEventListener('mouseleave', () => {
        if (isPlaying) {
          video.pause();
          video.currentTime = 0;
          isPlaying = false;
        }
      });
    }
  });
});
